module.exports = __webpack_public_path__ + "static/media/2S.33c964ae.png";